(function() {
  // Mobile nav toggle
  var burger = document.getElementById('BurgerBtn');
  var mobileNav = document.getElementById('MobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function() {
      var open = mobileNav.classList.toggle('open');
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open);
    });
  }

  // Sticky header shadow
  var header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', function() {
      header.style.boxShadow = window.scrollY > 40 ? '0 2px 16px rgba(0,0,0,0.08)' : 'none';
    }, { passive: true });
  }

  // Fade in on scroll
  if ('IntersectionObserver' in window) {
    var els = document.querySelectorAll('.shop-book__card, .service-card, .stylist-card, .features-bar__item');
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e, i) {
        if (e.isIntersecting) {
          setTimeout(function() {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
          }, i * 60);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      obs.observe(el);
    });
  }

  // Stylist flip cards — attach once, check screen width at click time
  document.querySelectorAll('.stylist-flip-card').forEach(function(card) {
    // Guard: only bind once using a data attribute flag
    if (card.dataset.flipBound) return;
    card.dataset.flipBound = '1';

    card.addEventListener('click', function(e) {
      // Only active on mobile
      if (window.innerWidth > 600) return;
      // Don't flip if they tapped a link (book button)
      if (e.target.closest('a')) return;
      card.classList.toggle('is-flipped');
    });
  });

})();
